import React from "react";
import { OrgSpaceWidgetAddScreenProps } from "./OrgSpaceWidgetAddDrawer";
import { WACategoryNoteComponent } from "../../Storecast/Storecast/WidgetAdd/Categories/WACategoryNote/WACategoryNote";
import { useOrgSpaceUnitSize } from "../OrgSpaces/useOrgSpaceUnitSize";

export function OrgSpaceWACategoryNote(
  props: OrgSpaceWidgetAddScreenProps<"OrgSpaceWACategoryNote">
) {
  const unitSize = useOrgSpaceUnitSize();
  return (
    <WACategoryNoteComponent
      maxSize={props.route.params.maxSize}
      unitSize={unitSize}
      onAdd={({ title, template }) => {
        props.navigation.navigateDeprecated("OrgSpaceWidgetAddNote", {
          maxSize: props.route.params.maxSize,
          template,
          title,
          spaceId: props.route.params.spaceId,
          position: props.route.params.position,
          workspaceId: props.route.params.workspaceId,
        });
      }}
      DATA_PREFIX="ORGSPACE_WA_CATEGORY_NOTE_PREVIEWS_QUERY:"
    />
  );
}
